import React from 'react';
import { Modal, Form, Button, DateRangePicker } from 'rsuite';
import { subDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { dateFns } from '@core/helpers';

export function FilterDate ({ show, onHide, handleSearch, setDateFrom, setDateTo }) {
    const { t } = useTranslation();
    const handleCancelChanges = () => {
        onHide();
    };

    // Main Component

    return (
        <Modal
            show={show}
            onHide={handleCancelChanges}
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('filter.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row m-0'>
                    <Form fluid>
                        <Form.Group className='mb-0 mr-2'>
                            <Form.ControlLabel srOnly>{t('filter.registrationDateRange')}</Form.ControlLabel>
                            <DateRangePicker
                                block
                                size='md'
                                placeholder={t('filter.registrationDateRange')}
                                limitEndYear={2019}
                                ranges={[{
                                    label: t('datepicker.yesterday'),
                                    value: [dateFns.addDays(new Date(), -1), dateFns.addDays(new Date(), -1)]
                                }, {
                                    label: t('datepicker.today'),
                                    value: [new Date(), new Date()]
                                }, {
                                    label: t('datepicker.last7Days'),
                                    value: [subDays(new Date(), 6), new Date()]
                                }, {
                                    label: t('datepicker.thisMonth'),
                                    value: [dateFns.startOfMonth(new Date()), new Date()]
                                }]}
                                // value={[dateFrom, dateTo]}
                                renderValue={(value, format) => {
                                    return `${dateFns.format(value[0], 'dd/MM/y')} ~ ${dateFns.format(value[1], 'dd/MM/y')}`;
                                }}
                                onChange={(ranges) => {
                                    setDateFrom((ranges && ranges[0]) || null);
                                    setDateTo((ranges && ranges[1]) || null);
                                }}
                            />
                        </Form.Group>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button appearance='primary' onClick={handleSearch} >{t('filter.search')}</Button>
                <Button appearance='subtle' onClick={handleCancelChanges} >{t('buttons.cancel')}</Button>
            </Modal.Footer>
        </Modal>
    );
};
